<template>
  <div class="nav-home">
    <h2 style="color: #fff;font-weight: 800;font-size: 40px;line-height: 3em">动物管理系统</h2>
    <a-row :gutter="32">
      <template v-for="(item, index) in cardList">
        <a-col :span="8" :key="index" @click="toPage">
          <a-row class="box-item" :style="{backgroundColor: item.bgColor}">
            <a-col :span="8" class="img-box">
              <img :src="item.imgSrc" alt="" class="card-img">
            </a-col>
            <a-col :span="16">
              <div class="pd-tb40" :style="{color: item.color}">
                <p style="font-weight: 900;font-size: 16px">{{ item.title }}</p>
                <p style="margin-top: 20px">{{ item.desc }}</p>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </template>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'NavHome',
  title: '导航首页',
  data() {
    return {
      cardList: [
        {
          title: '生物资产',
          desc: '动物资产的变动数据录入，含入馆、离馆、调拨、交换、租赁等场景',
          bgColor: '#fd844a',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card3.jpg')
        },
        {
          title: '饲养管理',
          desc: '记录动物日常饲喂及项目公司内调舍信息',
          bgColor: '#84cf1a',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card7.jpg')
        },
        {
          title: '环境管理',
          desc: '录入现场、水质、微生物、空气的日常检测信息',
          bgColor: '#9656f2',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card5.jpg')
        },
        {
          title: '医疗管理',
          desc: '录入动物检查记录，维护动物病案信息',
          bgColor: '#757be9',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card6.jpg')
        },
        {
          title: '繁殖管理',
          desc: '管理哺乳、海龟、企鹅、软骨鱼繁殖过程及后裔信息',
          bgColor: '#ff6779',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card4.jpg')
        },
        {
          title: '设备管理',
          desc: '记录设备运行情况及变更情况',
          bgColor: '#f4b613',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card8.jpg')
        },
        {
          title: '标准管理',
          desc: '维护环境和医疗标准',
          bgColor: '#22ad3a',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card9.jpg')
        },
        {
          title: '主数据管理',
          desc: '维护品种、动物档案、设备、药品基础数据统计报表',
          bgColor: '#3490f5',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card1.jpg')
        },
        {
          title: '统计报表',
          desc: '资产、繁殖、医疗、饲喂、环境相关查询报表',
          bgColor: '#fd844a',
          color: '#fafafa',
          imgSrc: require('@/assets/image/card2.jpg')
        },
      ]

    }
  },
  methods: {
    toPage() {
      this.$router.push({ path: '/dashboard/analysis' })
    }
  }
}
</script>

<style scoped>
.nav-home {
  height: 100vh;
  padding: 0 50px;
  background: url('../../assets/home1.png') no-repeat;
  background-size: 100% 100%;
}
.box-item {
  background: #fc77d3;
  height: 150px;
  margin-bottom: 30px;
  border-radius: 10px;
  border: 2px solid #fafafa;
}

.pd-tb40 {
  padding: 40px 0;
}

.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%
}

.card-img {
  height: 100px;
  width: 100px;
  border-radius: 50%
}
</style>